import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.79729 4.16699C1.72041 4.16699 0.833008 5.01744 0.833008 6.04943V14.4158C0.833008 15.4478 1.72041 16.2983 2.79729 16.2983H17.2021C18.2789 16.2983 19.1663 15.4478 19.1663 14.4158V6.04943C19.1663 5.01744 18.2789 4.16699 17.2021 4.16699H2.79729ZM2.94051 5.42195H17.0656L10.4021 11.1216C10.1481 11.3389 9.86554 11.3392 9.61092 11.1216L2.94051 5.42195ZM2.14253 6.42199L6.63038 10.2588L2.14253 14.3897V6.42199ZM17.8568 6.42199V14.3832L13.3826 10.2523L17.8568 6.42199ZM12.4005 11.0954L16.6769 15.0433H3.32246L7.61252 11.1019L8.7379 12.0628C9.45325 12.674 10.5597 12.675 11.2751 12.0628L12.4005 11.0954Z",
		fill: "currentColor"
	})
});
export default SvgInbox;
